module.exports = __webpack_public_path__ + "img/AmKienberg.f37d7dc6.svg";